import { Modal, ModalBody } from "reactstrap";

// SDD 034 - modal de selecao de papel, reaproveitado tanto no desafio pos-login (Login.js, com
// o preAuthToken) quanto na troca de papel em runtime (AdminNavbar.js, com o token completo
// atual) - a diferenca de qual token mandar no Bearer fica na chamada ao AuthService.selecionarPapel,
// nao neste componente. Controlado via props (isOpen/onSelecionar/onClose), diferente do padrao
// imperativo de singleton usado em SelecionarContrato.js, porque no login ainda nao existe
// state.user pra disparar a partir do AppContext (ver Decisao de escopo 1 da SDD 034).
export default function SelecionarPapel({ isOpen, papeis, onSelecionar, onClose }) {
  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalBody>
        <h2>Selecione o Papel</h2>
        {(papeis || []).map(papel => (
          <div
            className="rounded border px-2 py-1 mb-1 shadow"
            key={papel.idUsuarioPerfil}
            style={{ cursor: 'pointer' }}
            onClick={() => onSelecionar(papel.idUsuarioPerfil)}
          >
            {papel.nome}{papel.razaoSocial ? ` — ${papel.razaoSocial}` : ''}
          </div>
        ))}
      </ModalBody>
    </Modal>
  )
}
